import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Pricing } from '../components/Pricing';
import { Testimonials } from '../components/Testimonials';
import { CTA } from '../components/CTA';
import { usePublicConfig } from '../context';

export const HomePage = () => {
  const { config: publicConfig } = usePublicConfig();
  const chamaName = publicConfig?.name ?? 'LoopFund';

  return (
  <div className="flex flex-col gap-12 pb-20 lg:gap-16">
    <Hero />
    <section id="overview" className="section-padding mt-6">
      <div className="mx-auto grid max-w-6xl gap-8 lg:grid-cols-[1fr_minmax(320px,_420px)] lg:items-center">
        <div className="glass-surface relative overflow-hidden p-8">
          <h2 className="font-display text-2xl text-slate-900 dark:text-white">
            Built for movement, trusted for stewardship
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-500 dark:text-slate-300">
            {chamaName} members expect clarity. This hub adapts fluidly between smartphones and
            widescreen dashboards so the committee always has the same live numbers.
          </p>
          <div className="mt-6 grid gap-4 text-sm text-slate-600 dark:text-slate-300 sm:grid-cols-2">
            <div className="rounded-2xl border border-slate-200/60 p-4 dark:border-slate-800/60">
              <p className="font-semibold text-slate-900 dark:text-white">Small screens</p>
              <p className="mt-2 text-sm leading-relaxed">
                Fluid card layouts, haptic micro-interactions, and offline-ready views keep mobile
                members in flow.
              </p>
            </div>
            <div className="rounded-2xl border border-slate-200/60 p-4 dark:border-slate-800/60">
              <p className="font-semibold text-slate-900 dark:text-white">Large canvases</p>
              <p className="mt-2 text-sm leading-relaxed">
                Adaptive split-panels and widescreen analytics give executive teams clarity at a glance.
              </p>
            </div>
          </div>
        </div>
        <div className="glass-surface relative flex aspect-[4/5] items-center justify-center overflow-hidden">
          <div className="relative flex h-[88%] w-[82%] flex-col rounded-[2rem] border border-slate-200 bg-slate-50 p-5 shadow-inner dark:border-slate-800 dark:bg-slate-900">
            <div className="mx-auto mb-3 h-1.5 w-16 rounded-full bg-slate-200 dark:bg-slate-700" />
            <div className="grid flex-1 grid-rows-6 gap-3">
              <div className="rounded-2xl bg-brand-50 p-4 dark:bg-slate-800">
                <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand-700 dark:text-brand-200">
                  Member snapshot
                </p>
                <p className="mt-2 text-sm font-medium text-slate-900 dark:text-white">
                  Shiro W. - Cycle 6
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200/70 p-4 dark:border-slate-800/80">
                <p className="text-xs uppercase tracking-[0.35em] text-slate-400">Contribution status</p>
                <p className="mt-2 text-lg font-semibold text-slate-900 dark:text-white">
                  Paid - Nov 2025
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200/70 p-4 dark:border-slate-800/80">
                <p className="text-xs uppercase tracking-[0.35em] text-slate-400">Penalties due</p>
                <p className="mt-2 text-lg font-semibold text-brand-600 dark:text-brand-200">KES 0.00</p>
              </div>
              <div className="rounded-2xl border border-slate-200/70 p-4 dark:border-slate-800/80">
                <p className="text-xs uppercase tracking-[0.35em] text-slate-400">Next payout</p>
                <p className="mt-2 text-lg font-semibold text-slate-900 dark:text-white">
                  March 2026 - Priority
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200/70 p-4 dark:border-slate-800/80">
                <p className="text-xs uppercase tracking-[0.35em] text-slate-400">Concierge actions</p>
                <p className="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
                  Approve new member, review payout summary, broadcast meeting notes.
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200/70 p-4 dark:border-slate-800/80">
                <p className="text-xs uppercase tracking-[0.35em] text-slate-400">Sentiment</p>
                <p className="mt-2 text-lg font-semibold text-slate-900 dark:text-white">97% positive feedback</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Features />
    <Pricing />
    <Testimonials />
    <CTA />
  </div>
  );
};
